/**
 * @format
 * @flow
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addProduct, updateProduct, updateCartTotal, deleteProduct } from '../actions/cartAction';
import { Form } from 'react-bootstrap';
import swal from 'sweetalert2';
import { withTranslation } from 'react-i18next'

import { CartType, ProductType } from '../flowObjectType'
import '../styles/ProductDetail.scss'
import { BsXLg, BsTrashFill } from "react-icons/bs";

import { convertFirebaseUrlToCustomDomain, formatCurrency } from './Utils';
import sharedCartService from '../services/sharedCartService';
import { getTrans } from '../utils/translations';

import image1 from "../assets/allergen/1.png";
import image2 from "../assets/allergen/2.png";
import image3 from "../assets/allergen/3.png";
import image4 from "../assets/allergen/4.png";
import image5 from "../assets/allergen/5.png";
import image6 from "../assets/allergen/6.png";
import image7 from "../assets/allergen/7.png";
import image8 from "../assets/allergen/8.png";
import image9 from "../assets/allergen/9.png";
import image10 from "../assets/allergen/10.png";
import image11 from "../assets/allergen/11.png";
import image12 from "../assets/allergen/12.png";
import image13 from "../assets/allergen/13.png";
import image14 from "../assets/allergen/14.png";

const ImageData = {}
ImageData['gluten'] = image1
ImageData['arachide'] = image2
ImageData['coque'] = image3
ImageData['celeri'] = image4
ImageData['moutarde'] = image5
ImageData['oeuf'] = image6
ImageData['lait'] = image7
ImageData['poisson'] = image9
ImageData['crustace'] = image10
ImageData['mollusque'] = image11
ImageData['soja'] = image12
ImageData['anhydride'] = image13
ImageData['sesame'] = image8
ImageData['lupin'] = image14

const _ = require('lodash')

const placeholderSvg = `data:image/svg+xml,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="600" height="300" viewBox="0 0 600 300">
  <rect width="600" height="300" fill="#f3f4f6"/>
  <g transform="translate(276, 110)">
    <path fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
  </g>
</svg>
`)}`

const NoImageSVG = () => (
  <img
    alt="placeholder"
    className="product-img"
    src={placeholderSvg}
  />
)

type State = {
  productQuantity: number,
  comment: string
}

type Props = {
  show: boolean,
  closeModal: Function,
  addProduct: Function,
  updateProduct: Function,
  updateCartTotal: Function,
  deleteProduct: Function,
  openRecommendation: Function,
  cart: CartType,
  dropdown: any,
  product: ProductType,
  updateIndex?: number,
  productQuantity?: number,
  isRestoDisabled?: boolean,
  clickAndCollect?: boolean,
  type?: number,
  demo: boolean,
  options: any,
  readOnly?: boolean,
  settings: Object,
  canOrder?: boolean,
  cdnDomain?: ?string
}

const COMMENT_MAX_LENGTH = 100

const Toast = swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 1800,
})

const swalWithBootstrapButtons = swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

class ProductDetail extends Component<Props, State> {
  dropdown: any
  hasRubric: boolean
  rubric: []
  total: number
  totalHT: number
  totalVat: number
  subtotal: number
  subtotalHT: number
  product

  constructor(props: any) {
    super(props)
    this.dropdown = this.props.dropdown
    this.rubric = []
    this.total = 0
    this.totalHT = 0
    this.totalVat = 0
    this.subtotal = 0
    this.subtotalHT = 0
    this.options = this.props.options
    this.product = {}
  }

  state = {
    productQuantity: this.props.product.quantity ? this.props.product.quantity : 1,
    comment: typeof this.props.product.comment === 'string' ? this.props.product.comment.slice(0, COMMENT_MAX_LENGTH) : ''
  }

  getComment = (): string => {
    // Réglage désactivé : commentaire vide (aucune donnée saisie)
    if (!this.props.settings.productComments) return ''
    return (this.state.comment || '').trim()
  }

  getLang = (): string => this.props.settings.lang

  componentWillMount = () => {
    this.product = _.cloneDeep(this.props.product)
    if (this.product.rubric !== undefined && this.product.rubric.length) {
      this.rubric = _.cloneDeep(this.product.rubric)
    }

    if (this.product.rubrics && this.product.rubrics.length)
      this.rubric = this.getProductOptions(this.product)
    this.getProductPrice(this.product, this.state.productQuantity, false)
  }

  addQuantity = () => {
    if (this.state.productQuantity < 50) {
      this.getProductPrice(this.product, this.state.productQuantity + 1, false)
      this.setState((prevState) => ({ productQuantity: prevState.productQuantity + 1 }))
    }
  }

  removeQuantity = () => {
    if (this.state.productQuantity > 1) {
      this.getProductPrice(this.product, this.state.productQuantity - 1, false)
      this.setState((prevState) => ({ productQuantity: prevState.productQuantity - 1 }))
    }
  }

  getProductOptions = (product) => {
    const productRubrics = [];
    for (let i = 0; i < product.rubrics.length; ++i) {
      const platRubric = product.rubrics[i];

      for (let ii = 0; ii < this.options.length; ++ii) {
        const r = _.cloneDeep(this.options[ii])
        if (!r.shared && r.id === platRubric) {
          productRubrics.push(r);
        }
      }
    }
    return productRubrics;
  }

  selectRubric = (rubric: { checked: boolean }, checked: boolean, section: any) => () => {
    let totalSelectedQuantity = 0;
    for (let i = 0; i < section.data.length; ++i) {
      totalSelectedQuantity += section.data[i].quantity || 0;
    }
    if (totalSelectedQuantity === 0) {
      totalSelectedQuantity += section.selected
    }


    if (checked === true && totalSelectedQuantity >= section.selectMax && section.selectMax > 1) return

    if (checked === true) {
      if (section.selectMax === 1 && totalSelectedQuantity >= 1) { // online one choice
        section.data.forEach(choice => {
          choice.checked = false
        })
      }
      else {
        if (section.allowSameMultiple) {
          rubric.quantity = 1;
        }
        section.selected = section.selected ? section.selected + 1 : 1
      }
    }
    else {
      if (section.allowSameMultiple) {
        rubric.quantity = 0;
      }
      section.selected = section.selected ? section.selected - 1 : 0
    }
    rubric.checked = checked
    this.getProductPrice(this.product, this.state.productQuantity, false)
    this.forceUpdate()
  }

  rubricQuantityAdd = (rubric, section) => {
    let totalSelectedQuantity = 0;
    for (let i = 0; i < section.data.length; ++i) {
      totalSelectedQuantity += section.data[i].quantity || 0;
    }
    if (totalSelectedQuantity + 1 <= section.selectMax) {
      rubric.quantity += 1;
    }

    this.getProductPrice(this.product, this.state.productQuantity, false)
    this.forceUpdate();
  }

  rubricQuantityRemove = (rubric, section) => {
    if (rubric.quantity > 1) {
      rubric.quantity -= 1;
    }
    else {
      rubric.quantity = 0;
      rubric.checked = false;
    }

    section.selected = section.selected ? section.selected - 1 : 0

    this.getProductPrice(this.product, this.state.productQuantity, false)
    this.forceUpdate();
  }

  verifyProduct = () => {
    let error = false
    this.rubric.forEach((section) => {
      if (section.necessary === true && (typeof section.selected === 'undefined' || section.selected === 0)) {
        error = true
      }
      let selectedQuantity = 0
      section.data.forEach(data => {
        if (data.quantity)
          selectedQuantity += data.quantity ?? 0
        else if (data.checked)
          selectedQuantity += 1
      })
      if (section.necessary === true && selectedQuantity < section.selectMin) {
        error = true
      }
    })
    return error
  }

  addProduct = async () => {
    if (this.verifyProduct()) {
      swal.fire(this.props.t('error.incomplete'), this.props.t('error.pleaseSelect'), "error");
      return
    }

    const product = _.cloneDeep(this.product)

    const newProduct = {
      id: product.id,
      quantity: this.state.productQuantity,
      name: product.name,
      name_trans: product.name_trans ?? null,
      kitchenName: product.kitchenName ?? '',
      description: product.description ? product.description : '',
      description_trans: product.description_trans ?? null,
      comment: this.getComment(),
      unitPrice: product.unitPrice,
      unitPriceHT: product.unitPriceHT,
      discount: product.discount || null,
      tableDiscount: product.tableDiscount || null,
      takeawayDiscount: product.takeawayDiscount || null,
      deliveryDiscount: product.deliveryDiscount || null,
      image: product.image || null,
      vat: product.vat,
      rubric: _.cloneDeep(this.rubric),
      total: this.total,
      totalHT: this.totalHT,
      totalVat: this.totalVat,
      subtotal: this.subtotal,
      subtotalHT: this.totalHT
    }

    if (!product.kitchenName) {
      delete newProduct.kitchenName
    }

    // Handle Firebase-based shared cart addition
    if (this.props.settings.sharedCart && sharedCartService.isInSharedMode()) {
      try {
        await sharedCartService.addProduct(newProduct)
        // Firebase will automatically sync changes to Redux via listeners
        // Don't call getCartPrice() - let Firebase sync handle total calculation
      } catch (error) {
        console.error('Error adding product to Firebase cart:', error)
        // Fall back to local addition
        await this.props.addProduct(newProduct)
        await this.getCartPrice()
      }
    } else {
      // Regular local cart addition (not in shared mode)
      await this.props.addProduct(newProduct)
      await this.getCartPrice()
    }
    // this.dropdown.alertWithType('success', 'Produit ajouter', '');

    Toast.fire({
      icon: 'success',
      title: this.props.t('product.added')
    })
    this.props.closeModal()

    if (this.props.openRecommendation) {
      this.props.openRecommendation();
    }
  }

  updateProduct = async () => {
    if (this.verifyProduct()) {
      swal.fire(this.props.t('error.incomplete'), this.props.t('error.pleaseSelect'), "error");
      return
    }

    const { product, updateIndex } = this.props
    const newProduct = {
      id: product.id,
      quantity: this.state.productQuantity,
      name: product.name,
      name_trans: product.name_trans ?? null,
      description: product.description ? product.description : '',
      description_trans: product.description_trans ?? null,
      comment: this.getComment(),
      unitPrice: product.unitPrice,
      unitPriceHT: product.unitPriceHT,
      discount: product.discount || null,
      tableDiscount: product.tableDiscount || null,
      takeawayDiscount: product.takeawayDiscount || null,
      deliveryDiscount: product.deliveryDiscount || null,
      image: product.image || null,
      vat: product.vat,
      rubric: this.rubric,
      total: this.total,
      totalHT: this.totalHT,
      totalVat: this.totalVat,
      subtotal: this.total,
      subtotalHT: this.totalHT
    }

    // Handle Firebase-based shared cart update
    if (this.props.settings.sharedCart && sharedCartService.isInSharedMode()) {
      try {
        await sharedCartService.updateProduct(updateIndex, newProduct)
        // Firebase will automatically sync changes to Redux via listeners
        // Don't call getCartPrice() - let Firebase sync handle total calculation
      } catch (error) {
        console.error('Error updating product in Firebase cart:', error)
        // Fall back to local update
        await this.props.updateProduct(newProduct, updateIndex)
        await this.getCartPrice()
      }
    } else {
      // Regular local cart update (not in shared mode)
      await this.props.updateProduct(newProduct, updateIndex)
      await this.getCartPrice()
    }
    // this.dropdown.alertWithType('success', 'Panier modifier', '');
    this.props.closeModal()

  }

  getCartPrice = () => {
    const cart = this.props.cart
    if (cart.products.length === 0) {
      this.props.updateCartTotal(0, 0, 0, 0, 0)
      return
    }
    let cartTotal = 0
    let cartTotalHT = 0
    let cartTotalVat = 0
    let cartTotalProducts = 0
    let cartSubtotal = 0
    let cartSubtotalWithoutDiscount = this.getCartSubtotal(cart.products)
    let applyDiscount = false
    if (this.props.cart.orderType === 1 && cartSubtotalWithoutDiscount >= (this.props.settings.takeawaySettings.discountFrom ?? 0)) {
      applyDiscount = true
    } else if (this.props.cart.orderType === 4 && cartSubtotalWithoutDiscount >= (this.props.settings.deliverySettings.discountFrom ?? 0)) {
      applyDiscount = true
    }

    cart.products.forEach((product) => {
      const { total, totalHT, totalVat, subtotal } = this.getProductPrice(product, product.quantity, true, applyDiscount)
      cartTotal += total
      cartTotalHT += totalHT
      cartTotalVat += totalVat
      cartTotalProducts += product.quantity
      cartSubtotal += subtotal
    })

    // Update totals in Redux
    this.props.updateCartTotal(cartTotal, cartTotalHT, cartTotalVat, cartTotalProducts, cartSubtotal)

    // Sync totals to Firebase if in shared mode
    if (this.props.settings.sharedCart && sharedCartService.isInSharedMode()) {
      try {
        sharedCartService.updateCartTotals({
          total: cartTotal,
          totalHT: cartTotalHT,
          totalVat: cartTotalVat,
          totalProducts: cartTotalProducts,
          subtotal: cartSubtotal
        })
      } catch (error) {
        console.error('Error syncing totals to Firebase:', error)
      }
    }
  }

  getCartSubtotal = (products) => {
    const orderType = this.props.cart.orderType;
    let cartSubtotalWithoutDiscount = 0
    products.forEach((product) => {
      cartSubtotalWithoutDiscount += product.quantity * product.unitPrice
      product.rubric?.forEach((section) => {
        section.data.forEach((rubric) => {
          if (rubric.checked && rubric.unitPrice > 0) {
            if (section.allowSameMultiple) {
              cartSubtotalWithoutDiscount += product.quantity * rubric.unitPrice * (rubric.quantity || 1)
            }
            else {
              cartSubtotalWithoutDiscount += product.quantityquantity * rubric.unitPrice
            }
          }
        })
      })
      if (orderType === 1 && product.takeawayDiscount && product.takeawayDiscount.discount) {
        cartSubtotalWithoutDiscount = cartSubtotalWithoutDiscount * (1 - product.takeawayDiscount.discount / 100)
      }
      else if (orderType === 4 && product.deliveryDiscount && product.deliveryDiscount.discount) {
        cartSubtotalWithoutDiscount = cartSubtotalWithoutDiscount * (1 - product.deliveryDiscount.discount / 100)
      }
      else if ((orderType === 2 || orderType === 3) && product.tableDiscount && product.tableDiscount.discount) {
        cartSubtotalWithoutDiscount = cartSubtotalWithoutDiscount * (1 - product.tableDiscount.discount / 100)
      }
    })
    return cartSubtotalWithoutDiscount
  }

  getProductPrice = (product: ProductType, quantity: number, forTotal: boolean, applyDiscount: boolean): { total: number, totalHT: number, totalVat: number, subtotal: number } => {
    const rubric = forTotal ? product.rubric : this.rubric
    const orderType = this.props.cart.orderType;
    let rubricTotal = 0
    if (typeof product === 'undefined') return { total: 0, totalHT: 0, totalVat: 0 }
    let total = quantity * product.unitPrice
    let totalHT = quantity * product.unitPriceHT

    if (forTotal) {
      rubric.forEach((section) => {
        section.data.forEach((rubric) => {
          if (rubric.checked && rubric.unitPrice > 0) {
            if (section.allowSameMultiple) {
              total += quantity * rubric.unitPrice * (rubric.quantity || 1)
              totalHT += quantity * rubric.unitPriceHT * (rubric.quantity || 1)
            }
            else {
              total += quantity * rubric.unitPrice
              totalHT += quantity * rubric.unitPriceHT
            }
          }
        })
      })
    } else {
      rubric.forEach((section) => {
        section.data.forEach((rubric) => {
          if (rubric.checked && rubric.unitPrice > 0) {
            if (section.allowSameMultiple) {
              rubricTotal += quantity * rubric.unitPrice * (rubric.quantity || 1)
            }
            else {
              rubricTotal += quantity * rubric.unitPrice
            }

          }
        })
      })
    }
    // apply product discount
    if (orderType === 1 && product.takeawayDiscount && product.takeawayDiscount.discount) {
      total = total * (1 - product.takeawayDiscount.discount / 100)
      totalHT = totalHT * (1 - product.takeawayDiscount.discount / 100)
    }
    else if (orderType === 4 && product.deliveryDiscount && product.deliveryDiscount.discount) {
      total = total * (1 - product.deliveryDiscount.discount / 100)
      totalHT = totalHT * (1 - product.deliveryDiscount.discount / 100)
    }
    else if ((orderType === 2 || orderType === 3) && product.tableDiscount && product.tableDiscount.discount) {
      total = total * (1 - product.tableDiscount.discount / 100)
      totalHT = totalHT * (1 - product.tableDiscount.discount / 100)
    }

    let subtotal = total

    // apply cart discount
    if (this.props.cart.discount && applyDiscount) {
      if (
        (orderType === 1 && (!product.takeawayDiscount || (product.takeawayDiscount && product.takeawayDiscount.canDiscount))) ||
        (orderType === 4 && (!product.deliveryDiscount || (product.deliveryDiscount && product.deliveryDiscount.canDiscount))) ||
        ((orderType === 2 || orderType === 3) && (!product.tableDiscount || (product.tableDiscount && product.tableDiscount.canDiscount)))
      ) {
        total = total * (1 - this.props.cart.discount / 100)
        totalHT = totalHT * (1 - this.props.cart.discount / 100)
      }
    }

    this.total = total
    this.totalHT = totalHT
    this.totalVat = total - totalHT
    this.subtotal = total
    this.subtotalHT = totalHT
    return { total, totalHT, totalVat: this.totalVat, subtotal }
  }

  deleteProduct = async () => {
    const { updateIndex } = this.props

    // Handle Firebase-based shared cart deletion
    if (this.props.settings.sharedCart && sharedCartService.isInSharedMode()) {
      try {
        await sharedCartService.removeProduct(updateIndex)
        // Firebase will automatically sync changes to Redux via listeners
        // Don't call getCartPrice() - let Firebase sync handle total calculation
      } catch (error) {
        console.error('Error removing product from Firebase cart:', error)
        // Fall back to local deletion
        this.props.deleteProduct(updateIndex)
        this.getCartPrice()
      }
    } else {
      // Regular local cart deletion (not in shared mode)
      this.props.deleteProduct(updateIndex)
      this.getCartPrice()
    }
    // this.dropdown.alertWithType('success', 'Produit supprimer');
    this.props.closeModal()
  }

  deleteProductAlert = () => {

    swalWithBootstrapButtons.fire({
      title: this.props.t('product.deleteConfirm'),
      showDenyButton: false,
      showCancelButton: true,
      icon: 'warning',
      confirmButtonText: this.props.t('product.deleteYes'),
      cancelButtonText: this.props.t('common.cancel'),
      denyButtonText: this.props.t('product.deleteNo'),
      reverseButtons: true
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.deleteProduct()
      } else if (result.isDenied) {
        // Swal.fire('Changes are not saved', '', 'info')
      }
    })

    // var r = window.confirm("Confirmer la suppression ?");
    // if (r === true) {
    //   this.deleteProduct()
    // }
  }

  getLabel = () => {
    if (this.props.demo)
      return this.props.t('product.demo')
    if (this.props.isRestoDisabled)
      return this.props.t('product.closed')
    return this.props.t('product.addToCart', { price: formatCurrency(this.subtotal, this.props.settings.currencySymbol) })
  }

  renderProductInfo = () => {
    const { product } = this.props
    if (typeof product === 'undefined') return <div />
    const hasImage = typeof product.image !== 'undefined' && product.image.path !== '' && product.image.enable
    const orderType = this.props.cart.orderType;
    const unitPrice = parseFloat(product.unitPrice);

    let discountPrice = ``;
    let hasDiscount = false;
    let discountLabel = '';
    if (orderType === 1 && product.takeawayDiscount && product.takeawayDiscount.discount) {
      discountPrice = unitPrice * (1 - product.takeawayDiscount.discount / 100)
      hasDiscount = true;
      discountLabel = this.props.t('product.immediateDiscount', { discount: product.takeawayDiscount.discount })
    }
    else if (orderType === 4 && product.deliveryDiscount && product.deliveryDiscount.discount) {
      discountPrice = unitPrice * (1 - product.deliveryDiscount.discount / 100)
      hasDiscount = true;
      discountLabel = this.props.t('product.immediateDiscount', { discount: product.deliveryDiscount.discount })
    }
    else if ((orderType === 2 || orderType === 3) && product.tableDiscount && product.tableDiscount.discount) {
      discountPrice = unitPrice * (1 - product.tableDiscount.discount / 100)
      hasDiscount = true;
      discountLabel = this.props.t('product.immediateDiscount', { discount: product.tableDiscount.discount })
    }
    const isFidelityDiscount = hasDiscount ? product.discount && product.discount.isFidelityDiscount : false

    return (
      <div className="product-info-block">

        {this.props.updateIndex === undefined && (
          <button className="back-btn" onClick={this.props.closeModal}><BsXLg size="2em" /></button>
        )}
        {this.props.updateIndex !== undefined && (
          <button className="delete-btn" onClick={this.deleteProductAlert}><BsTrashFill size="1.2em" /></button>
        )}
        {hasImage && (

          <img
            alt="produit"
            className="product-img"
            src={convertFirebaseUrlToCustomDomain(product.image.path, this.props.cdnDomain)}
          />
        )}

        {!hasImage && <NoImageSVG />}


        <div className="productName">
          {getTrans(this.product, 'name', this.getLang())}
        </div>

        <div />

        {product.description != null && product.description.trim() !== '' && (
          <div className="product-description" style={{ whiteSpace: 'pre-line' }}>{getTrans(product, 'description', this.getLang())}</div>
        )}

        {hasDiscount && !isFidelityDiscount && (
          <div className="product-price" style={{ alignItems: 'center' }}>
            <span style={{ textDecoration: 'line-through' }}>{formatCurrency(unitPrice, this.props.settings.currencySymbol)}</span>
            <span> {formatCurrency(parseFloat(discountPrice), this.props.settings.currencySymbol)}</span>
            <div style={{ flexDirection: 'row' }}>
              <span>{discountLabel}</span>
              {/* <img
                source={require('../../assets/icon/banking.png')}
                resizeMode="contain"
                style={{ width: 25, height: 25 }}
              /> */}
            </div>
          </div>
        )}

        {!hasDiscount && product.unitPrice > 0 && (
          <div className="product-price">{formatCurrency(unitPrice, this.props.settings.currencySymbol)}</div>
        )}
      </div>
    )
  }

  renderQuantity = () => {
    const { product } = this.props
    if (typeof product === 'undefined') return <div />
    return (
      <div className="quantityBlock">
        <button className="quantityBtn" onClick={this.removeQuantity}>-</button>
        <button className="totalQty">{this.state.productQuantity}</button>
        <button className="quantityBtn" onClick={this.addQuantity}>+</button>
      </div>
    )
  }

  renderContent = () => {
    return (
      <div className="content-block">
        {this.rubric.map((section) => {
          const sectionHeader = this.renderSectionHeader({ section })
          const hasImage = section.data.some(item => item.image && item.image.path)
          return section.data.map((item, idx) => {
            const sectionItem = this.renderRubric({ item, index: section.index, section, hasImage })
            if (idx === 0) return <div key={section.index + section.rubricName}>{sectionHeader}{sectionItem}</div>
            return sectionItem
          })
        })}
      </div>
    )
  }

  renderSectionHeader = ({ section }: { section: any }) => {
    const { selectMin, selectMax, necessary } = section
    const rubricName = getTrans(section, 'rubricName', this.getLang())
    let name = ''
    if (selectMin === selectMax && selectMax !== 1)
      name = `${selectMin} ${rubricName} `
    else if (selectMax !== 1)
      name = this.props.t('product.maxChoices', { name: rubricName, max: selectMax })
    else
      name = rubricName
    return (
      <div
        className="section-header"
        key={section.rubricName + section.index}
      >
        <div>{name} {necessary && this.props.t('product.required')}</div>
      </div>

    )
  }

  renderRubric = ({ item, index, section, hasImage }: { item: any, index: number, section: any, hasImage?: boolean }) => {
    if (item.displayApp === false) return <div />
    const unitPrice = item.unitPrice ? `+ ${formatCurrency(parseFloat(item.unitPrice), this.props.settings.currencySymbol)}` : ''
    const imagePath = item.image && item.image.path ? item.image.path : ''
    const canOrder = item.canOrder ?? true
    const itemName = getTrans(item, 'name', this.getLang())
    return (
      <div
        className="rubricItem"
        onClick={this.selectRubric(item, !item.checked, section)}
        key={section.index + item.name}
      >

        {!this.props.readOnly && this.props.canOrder && (
          <Form.Check
            size={"lg"}
            checked={item.checked || false}
            type={section.necessary && section.selectMax === 1 ? 'radio' : 'checkbox'}
            onChange={() => { }}
            color="red"
          />
        )}
        {hasImage && (
          <div className={`rubric-item-image-container${imagePath ? '' : ' rubric-no-image'}${canOrder ? '' : ' rubric-disabled'}`}>
            {imagePath ? (
              <img
                className="rubric-item-image"
                src={convertFirebaseUrlToCustomDomain(imagePath, this.props.cdnDomain)}
                alt={itemName}
                loading="lazy"
              />
            ) : (
              <img
                className="rubric-item-image rubric-image-placeholder"
                src={placeholderSvg}
                alt=""
              />
            )}
          </div>
        )}
        <div className="rubric-name">
          {item.name.startsWith('www.') && (
            <span><a target="_blank" rel="noopener noreferrer" href={`//${item.name}`}>{item.name}</a></span>
          )}
          {!item.name.startsWith('www.') && (
            <span>{itemName}</span>
          )}
        </div>
        <div className="rubric-price">
          <span>{unitPrice}</span>
        </div>

        {section.allowSameMultiple && item.checked && (
          <div className="rubric-quantity-container" onClick={(e) => e.stopPropagation()}>
            <span className="rubric-quantity-control" onClick={() => this.rubricQuantityRemove(item, section)}>-</span>
            <span className="rubric-quantity-number">{item.quantity}</span>
            <span className="rubric-quantity-control" onClick={() => this.rubricQuantityAdd(item, section)}>+</span>
          </div>
        )}
      </div>
    )
  }

  renderAllergen = () => {
    const { product } = this.props
    if (!product) return null;
    const allergen = product.allergene ?? []

    const TextData = {}
    TextData['gluten'] = this.props.t('modalAllergen.gluten')
    TextData['arachide'] = this.props.t('modalAllergen.arachide')
    TextData['coque'] = this.props.t('modalAllergen.coque')
    TextData['celeri'] = this.props.t('modalAllergen.celeri')
    TextData['moutarde'] = this.props.t('modalAllergen.moutarde')
    TextData['oeuf'] = this.props.t('modalAllergen.oeuf')
    TextData['lait'] = this.props.t('modalAllergen.lait')
    TextData['poisson'] = this.props.t('modalAllergen.poisson')
    TextData['crustace'] = this.props.t('modalAllergen.crustace')
    TextData['mollusque'] = this.props.t('modalAllergen.mollusque')
    TextData['soja'] = this.props.t('modalAllergen.soja')
    TextData['anhydride'] = this.props.t('modalAllergen.anhydride')
    TextData['sesame'] = this.props.t('modalAllergen.sesame')
    TextData['lupin'] = this.props.t('modalAllergen.lupin')

    return (
      <div className="allergen-block">
        {allergen.map((name) =>
          <div className="allergen-detail" key={name}>
            <img
              alt="produit"
              className="product-img"
              src={ImageData[`${name}`]}
              width={30}
              height={30}
            />
            <div className="allergen-name">{TextData[`${name}`]}</div>
          </div>
        )}
      </div>
    )
  }

  renderOption = ({ item, index, section }: { item: any, index: number, section: any }) => {
    if (item.displayApp === false) return <div />
    const unitPrice = item.unitPrice ? `+ ${formatCurrency(parseFloat(item.unitPrice), this.props.settings.currencySymbol)}` : ''
    return (
      <div
        className="rubricItem"
        onClick={this.selectRubric(item, !item.checked, section)}
        key={section.index + item.name}
      >
        <div>
          <Form.Check
            size={"lg"}
            checked={item.checked || false}
            type={item.necessary ? 'radio' : 'checkbox'}
            onChange={() => { }}
          />
        </div>
        <div className="rubric-name">
          <span>{getTrans(item, 'name', this.getLang())}</span>
        </div>
        <div className="rubric-price">
          <span>{unitPrice}</span>
        </div>
      </div>
    )

  }

  renderComment = () => {
    if (!this.props.settings.productComments) return null
    const comment = this.state.comment || ''
    return (
      <div className="product-comment-block">
        <label className="product-comment-label" htmlFor="product-comment-input">{this.props.t('product.commentLabel')}</label>
        <Form.Control
          id="product-comment-input"
          as="textarea"
          rows="2"
          maxLength={COMMENT_MAX_LENGTH}
          placeholder={this.props.t('product.commentPlaceholder')}
          value={comment}
          onChange={(e) => this.setState({ comment: e.target.value.slice(0, COMMENT_MAX_LENGTH) })}
        />
        <div className="product-comment-counter">{comment.length}/{COMMENT_MAX_LENGTH}</div>
      </div>
    )
  }

  renderFooter = () => {
    return (
      <div>
        {this.props.updateIndex === undefined && (
          <div className="modalFooter">
            <div className="confirm-btn rounded-lg" onClick={this.addProduct}>
              {this.getLabel()}
            </div>
          </div>
        )}

        {this.props.updateIndex !== undefined && (
          <div className="modalFooter">
            <div className="confirm-btn rounded-lg" onClick={this.updateProduct}>
              {this.props.t('product.update', { price: formatCurrency(this.props.cart.subtotal, this.props.settings.currencySymbol) })}
            </div>
          </div>
        )}
      </div>
    )
  }

  render() {
    return (
      <div className="modalContainer">
        <div className="scrollable-content">
          {this.renderProductInfo()}
          {this.renderContent()}
          {this.renderAllergen()}
          {!this.props.readOnly && this.props.canOrder && (
            this.renderComment()
          )}
          {!this.props.readOnly && this.props.canOrder && (
            this.renderQuantity()
          )}

        </div>
        {!this.props.readOnly && this.props.canOrder && (
          this.renderFooter()
        )}
      </div>
    );
  }
}

// redux
const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    settings: state.settings
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addProduct: (product) => dispatch(addProduct(product)),
    updateProduct: (product, idx) => dispatch(updateProduct(product, idx)),
    updateCartTotal: (cartTotal, cartTotalHT, cartTotalVat, cartTotalProducts, cartSubtotal) => dispatch(updateCartTotal(cartTotal, cartTotalHT, cartTotalVat, cartTotalProducts, cartSubtotal)),
    deleteProduct: (idx) => dispatch(deleteProduct(idx))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProductDetail))